import React from 'react';
import { motion } from 'framer-motion';
const faqs = [{
  q: '¿Es un producto físico o digital?',
  a: 'Es 100% digital. Recibirás acceso inmediato a todos los PDFs en tu correo en menos de 5 minutos. Puedes leerlo en tu móvil, tablet o PC, o imprimirlo. No hay nada que esperar ni instalar.'
}, {
  q: '¿Sirve si mi bebé ya tiene varios meses?',
  a: 'Sí. Cada tomo está segmentado por etapa. Si tu bebé tiene entre 0 y 6 meses, empieza por el Tomo I. Si tiene entre 6 y 12 meses, ve directamente al Tomo II. No tienes que leerlo todo desde el principio.'
}, {
  q: '¿Cuándo empezaré a notar resultados?',
  a: 'Muchos padres aplican algo útil el mismo día que reciben el acceso. El Bono 1 de Respuestas Rápidas está diseñado específicamente para esa noche. Los cambios más profundos en sueño y rutinas suelen verse en 5-7 días de aplicación consistente.'
}, {
  q: '¿El pago es seguro?',
  a: 'Sí. El pago está protegido con encriptación SSL de 256 bits. No guardamos datos de tarjeta. El proceso es igual de seguro que cualquier compra en Amazon o El Corte Inglés.'
}, {
  q: '¿Cómo funciona la garantía?',
  a: 'Tienes 7 días desde la compra para probarlo todo. Si no estás satisfecho, escribes a soporte@cherubagency.com y te devolvemos el 100% sin preguntas ni demoras.'
}, {
  q: '¿Está en español?',
  a: 'Sí. Todo el sistema, los tomos y los 3 bonos están íntegramente en español. Escrito para familias hispanohablantes, sin tecnicismos innecesarios.'
}];
export function FAQSection() {
  return <section className="bg-white py-[72px] px-5" data-id="element-45">
      <div className="max-w-[820px] mx-auto" data-id="element-46">
        <div className="text-center" data-id="element-47">
          <span className="text-[0.75rem] tracking-[0.18em] uppercase text-[#8899aa] mb-3 block" data-id="element-48">
            Resolvemos tus dudas
          </span>
          <h2 className="font-serif text-navy mb-5 text-[clamp(1.6rem,3.5vw,2.4rem)]" data-id="element-49">
            Preguntas frecuentes
          </h2>
          <div className="w-12 h-[3px] bg-gold mx-auto mb-9" data-id="element-50" />
        </div>

        <div className="max-w-[700px] mx-auto" data-id="element-51">
          {faqs.map((f, i) => <motion.div key={f.q} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="border-b border-[#ebebeb] py-5" data-id="element-52">
              <p className="text-base text-navy font-bold mb-2.5" data-id="element-53">{f.q}</p>
              <p className="text-[0.92rem] text-[#666]" data-id="element-54">{f.a}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}